<template>
  <div>
    <div v-if="!$store.state.search">
      <div v-if="projects.length > 0" class="mb-fix">
        <div class="text__header p-10">{{ $t('messages.kickstarters') }}</div>
        <masonry :cols="cols" :gutter="{ default: '15px' }"
                 class="masonry">
          <project-tile v-for="project in projects" :project="project" :key="'proj' + project.id"></project-tile>
        </masonry>
      </div>
      <div v-if="productsHighlight.length > 0" class="mb-fix">
        <div class="text__header p-10">{{ $t('messages.highlights') }}</div>
        <masonry :cols="cols" :gutter="{ default: '15px' }"
                 class="masonry">
          <product-tile v-for="product in productsHighlight" :product="product" :key="'prodhg' + product.id"></product-tile>
        </masonry>
      </div>
      <div v-if="products.length > 0" class="mb-fix">
        <div class="text__header p-10">{{ $t('messages.latest') }}</div>
        <masonry :cols="cols" :gutter="{ default: '15px' }"
                 class="masonry" v-if="products.length > 0">
          <product-tile v-for="product in products" :product="product" :key="'prod' + product.id"></product-tile>
        </masonry>
      </div>
    </div>
    <div v-if="$store.state.search">
      <div v-if="projects.length > 0" class="mb-fix">
        <div class="text__header p-10">{{ $t('messages.kickstarters') }}</div>
        <masonry :cols="cols" :gutter="{ default: '15px' }"
                 class="masonry">
          <project-tile v-for="project in projects" :project="project" :key="'proj' + project.id"></project-tile>
        </masonry>
      </div>
      <div v-if="products.length > 0" class="mb-fix">
        <div class="text__header p-10">{{ $t('messages.games') }}</div>
        <masonry :cols="cols" :gutter="{ default: '15px' }"
                 class="masonry" v-if="products.length > 0">
          <product-tile v-for="product in products" :product="product" :key="'prod' + product.id"></product-tile>
        </masonry>
      </div>
      <div class="alert alert-danger products-div m-10" v-if="projects.length === 0 && products.length === 0">
        {{ $t('messages.products_empty_all') }}
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueMasonry from 'vue-masonry-css'
import ProjectTile from '../components/project/ProjectTile'
import ProductTile from '../components/product/ProductTile'

import { defaultMixin } from '../mixin/default'
import { projectMixin } from '../mixin/project'
import { navigationMixin } from '../mixin/navigation'

import { projectService } from '../services/project.service'
import { productService } from '../services/product.service'

Vue.use(VueMasonry)

export default {
  name: 'landingdashboard',
  mixins: [ defaultMixin, projectMixin, navigationMixin ],
  components: { ProjectTile, ProductTile },
  data: function () {
    return {
      cols: {
        default: 6,
        1600: 5,
        1300: 4,
        1000: 2,
        700: 1
      },
      rows: 1,
      projects: [],
      productsHighlight: [],
      products: [],
      loader: null,
      initialized: 0
    }
  },
  methods: {
    fetchProjects: function () {
      let size = this.calculateSize() * this.rows

      if (!this.loader) {
        this.loader = this.$loading.show()
      }
      let store = this.$store
      let filter = {
        search: store.state.search,
        page: 1,
        size: size
      }

      projectService.fetch(filter)
        .then((projects) => {
          this.projects = projects

          this.initialized++
          if (this.initialized === 3) {
            this.loader.hide()
            this.$store.commit('moveToScrollPosition')
          }
        }, () => {
          store.commit('error', 'errors.projects')
          this.initialized++
          if (this.initialized === 3) {
            this.loader.hide()
          }
        })
    },
    fetchProducts: function (highlight) {
      let size = this.calculateSize() * (this.$store.state.search ? (this.rows * 2) : this.rows)

      if (!this.loader) {
        this.loader = this.$loading.show()
      }
      let store = this.$store
      let filter = {
        search: store.state.search,
        page: 1,
        size: size,
        highlight: highlight,
        category: 'all'
      }

      productService.fetch(filter)
        .then((products) => {
          if (highlight) {
            this.productsHighlight = products
          } else {
            this.products = products
          }

          this.initialized++
          if (this.initialized === 3) {
            this.loader.hide()
            this.$store.commit('moveToScrollPosition')
          }
        }, () => {
          store.commit('error', 'errors.projects')
          this.initialized++
          if (this.initialized === 3) {
            this.loader.hide()
          }
        })
    },
    calculateSize: function () {
      let size = null
      let screenWidth = window.innerWidth
      for (let key in this.cols) {
        if (size === null) {
          if (key !== 'default' && screenWidth <= key) {
            size = this.cols[key]
          } else if (key === 'default') {
            size = this.cols[key]
          }
        }
      }
      if (screenWidth <= 700) {
        size = size * 6
      } else if (screenWidth <= 1000) {
        size = size * 3
      }
      return size
    }
  },
  created: function () {
    this.fetchProjects()
    this.fetchProducts(true)
    this.fetchProducts(false)
    this.$root.$on('search', () => {
      this.products = []
      this.projects = []
      this.fetchProjects()
      this.fetchProducts(false)
    })
  },
  beforeDestroy: function () {
    this.$root.$off('search')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .card__gutter__left {
    margin-right: 10px !important;
  }

  .card__gutter__right {
    margin-left: 10px !important;
  }

  .masonry {
    padding: 10px;
  }

  @media screen and (min-width: 901px) {
    .w-33-responsive {
      width: 33.3%;
    }
  }

  .mb-fix {
    margin-bottom: -20px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/LandingDashboard.vue